<div class="typeahead-container">
  <input
    #typeaheadInput
    class="input-base leading-icon-padding"
    type="text"
    [class.input-error]="error()"
    autocomplete="off"
    [class]="{
      'input-large': inputSize() === InputSize.large,
      'input-small': inputSize() === InputSize.small,
      'trailing-icon-padding': clearButtonVisible(),
      'result-selected': currentSelectedResult() !== null && showSelectedValue(),
    }"
    [attr.id]="controlId()"
    [value]="value()"
    [disabled]="disabled()"
    [placeholder]="placeholder()"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (input)="handleInput($event)" />
  <mat-icon
    class="typeahead-icon typeahead-search-icon"
    [class]="{
      'typeahead-icon-large': inputSize() === InputSize.large,
      'typeahead-icon-small': inputSize() === InputSize.small,
    }"
    [svgIcon]="'search'">
  </mat-icon>
  <mat-icon
    [hidden]="!clearButtonVisible()"
    (click)="clear()"
    class="typeahead-icon typeahead-clear-icon"
    [class]="{
      'typeahead-icon-large': inputSize() === InputSize.large,
      'typeahead-icon-small': inputSize() === InputSize.small,
      'disabled': disabled(),
    }"
    [svgIcon]="'close'">
  </mat-icon>
</div>

<div
  class="typeahead-results-content"
  [class.match-input-width]="resultsMatchesInputWidth()"
  [hidden]="!showResultsContent()"
  #typeaheadResults>
  @if (loading()) {
    <div class="px-3">
      <lib-loading-shimmer></lib-loading-shimmer>
    </div>
  } @else if ((results()?.length ?? 0) === 0) {
    <div class="px-3 font-label-small font-semi-bold" i18n>No Results</div>
  } @else {
    @for (result of results(); track $index) {
      <div class="typeahead-result-item" (mousedown)="$event.preventDefault()" (click)="resultSelected($index)">
        {{ result }}
      </div>
    }
  }
</div>
